import ApiService from "@/core/services/api.service";
import { BaseService } from "@/components/Tools/baseService";

let url = process.env.VUE_APP_API_ADMIN;

class FlowCategories extends BaseService {
  getAll() {
    return ApiService.get(url, "flow_categories");
  }
}
export default new FlowCategories();
